<template>
  <div>
    <!-- <div class="loading box_renew-loading" id="loading"><div class="loading-wrap"><span class="box_loading-area"><img src="./images/img_loading-renewal.gif" alt="로딩중"></span></div></div> -->
    <h1 class="logo_img">amway</h1>
    <div class="mask_index-wrap">
      <div class="mask_img pc_block">
        <img src="./images/main_product.png" alt="">
      </div>
      <div class="mask_info">
        <p class="product_logo">atomsphere sky</p>
        <p class="product_name">엣모스피어 스카이<br><span class="txt_strong">미세먼지마스크</span><span class="txt_kf">KF94</span></p>
        <p class="product_info">엣모스피어 스카이 미세먼지마스크 KF94(의약외품)는 4중구조의 <br>KF94 필터를 적용해 미세먼지와 황사로부터 호흡기를 보호해줍니다.</p>
        <div class="mask_img m_block">
          <img src="./images/main_product.png" alt="">
        </div>
        <div class="mobile-floating">
          <div class="box_button-a">
            <button type="button" class="btn_mobile open_reservation" @click='gotoreserv'><i class="ico_01"></i>마스크 예약</button>
          </div>
          <div class="box_button-b st_type02">
            <a href="https://www.amway.co.kr/register" class="btn_type-b" style="display: none;">회원가입</a>
            <a href="https://www.amway.co.kr" class="btn_type-c">암웨이 홈으로</a>
          </div>
          <p class="txt_noti">다른 제품 주문을 위해 amway.co.kr 홈으로 이동합니다.</p>
        </div>
      </div>
    </div>
    <div class="layer_popup layer_reservation">
      <object id="" width="100%" height="100%" data="mask_reservations_2.html"></object>
      <button type="button" class="layer_close">닫기</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

export default {
  name: 'atmosphere-mask-index',
  data () {
    return {
      url: document.location.href
    }
  },
  methods: {
    gotoreserv () {
      window.open(this.url.replace('index', 'share'), '_self')
    }
  },
  mounted: function () {
    // body color
    document.body.className = 'gate_page'
    // user agent check
    var ua = navigator.userAgent.toLowerCase()
    console.log(ua)
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:300,400,500,700&subset=korean');
@import './css/mask2.css';
</style>



// WEBPACK FOOTER //
// src/views/atmosphere-mask/index.vue